import { HTML_LANG, type Lang } from "./translate";

const CODES = "AF AL DZ AD AO AG AR AM AU AT AZ BS BH BD BB BY BE BZ BJ BT BO BA BW BR BN BG BF BI CV KH CM CA CF TD CL CN CO KM CG CD CR CI HR CU CY CZ DK DJ DM DO EC EG SV GQ ER EE SZ ET FJ FI FR GA GM GE DE GH GR GD GT GN GW GY HT HN HK HU IS IN ID IR IQ IE IL IT JM JP JO KZ KE KI KP KR XK KW KG LA LV LB LS LR LY LI LT LU MO MG MW MY MV ML MT MH MR MU MX FM MD MC MN ME MA MZ MM NA NR NP NL NZ NI NE NG MK NO OM PK PW PS PA PG PY PE PH PL PT PR QA RO RU RW KN LC VC WS SM ST SA SN RS SC SL SG SK SI SB SO ZA SS ES LK SD SR SE CH SY TW TJ TZ TH TL TG TO TT TN TR TM TV UG UA AE GB UY UZ VU VA VE VN YE ZM ZW".split(" ");

const cache = new Map<Lang, [string, string][]>();

function names(locale: string): Intl.DisplayNames | null {
  try {
    return new Intl.DisplayNames([locale], { type: "region" });
  } catch {
    return null;
  }
}

export function countryOptions(lang: Lang): [string, string][] {
  const hit = cache.get(lang);
  if (hit) return hit;
  const en = names("en");
  const local = names(HTML_LANG[lang]) ?? en;
  const rows = CODES.map((code): [string, string] => {
    const english = en?.of(code) ?? code;
    return [english, local?.of(code) ?? english];
  }).sort((a, b) => a[1].localeCompare(b[1], HTML_LANG[lang]));
  cache.set(lang, rows);
  return rows;
}
